export interface Recent { k: string; id: string; title: string; sub: string; to: string; at: number }
const KEY = "console-recent";
const MAX = 8;

const read = (): Recent[] => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

/** Remember something the user opened so the search can offer it again in one tap (last 8, newest first, de-duplicated by target). */
export function remember(r: Omit<Recent, "at">) {
  const next = [{ ...r, at: Date.now() }, ...read().filter((x) => x.to !== r.to)].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event("console-recent-changed"));
}

export function recents(): Recent[] { return read(); }
